import React, { useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import {
  Dialog,
  withStyles,
  DialogActions,
  DialogContent,
  withMobileDialog,
} from '@material-ui/core'
import { openImageDialog } from 'actions/view'
import Button from 'components/theme/Button'

const urlParams = new URLSearchParams(window?.location?.search)
const jwtToken = urlParams?.get?.('jwtToken')

export default withRouter(
  connect(
    state => ({
      dialogOpen: state.view.imageDialogOpen,
    }),
    dispatch => bindActionCreators({ openImageDialog }, dispatch),
  )(
    withMobileDialog()(
      withStyles(theme => ({
        rounded: {
          borderRadius: 28,
          overflowY: 'hidden',
          height: '100%',
          [theme.breakpoints.down('sm')]: {
            borderRadius: 0,
            overflowY: 'auto',
          },
        },
        dialogContentRoot: {
          textAlign: 'center',
          padding: 0,
          '&:first-child': {
            paddingTop: 0,
          },
        },
      }))(({ fullScreen, dialogOpen, classes, openImageDialog, history }) => {
        const [zoomed, toggleZoomed] = useState(false)

        // const download = async () => {
        //   const originalImage = dialogOpen
        //   const image = await fetch(originalImage, { mode: 'no-cors' })

        //   //Split image name
        //   const nameSplit = originalImage.split('/')
        //   const duplicateName = nameSplit.pop()

        //   const imageBlog = await image.blob()
        //   const imageURL = URL.createObjectURL(imageBlog)
        //   const link = document.createElement('a')
        //   link.href = imageURL
        //   link.download = '' + duplicateName + ''
        //   document.body.appendChild(link)
        //   link.click()
        //   document.body.removeChild(link)
        // }

        const MyLink = props => (
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          <a
            href={dialogOpen}
            target="_blank"
            rel="noopener noreferrer"
            {...props}
          />
        )

        return (
          <Dialog
            fullWidth
            maxWidth="xl"
            fullScreen={fullScreen}
            open={Boolean(dialogOpen)}
            onClose={() => openImageDialog(false)}
            aria-labelledby="responsive-dialog-title"
            PaperProps={{ classes: { rounded: classes.rounded } }}
          >
            <DialogContent classes={{ root: classes.dialogContentRoot }}>
              <img
                onClick={() => toggleZoomed(!zoomed)}
                alt="attachment"
                style={{
                  maxWidth: zoomed ? undefined : '100%',
                  maxHeight: zoomed ? undefined : 'calc(100% - 3.5px)',
                  cursor: zoomed ? 'zoom-out' : 'zoom-in',
                }}
                src={dialogOpen}
              />
            </DialogContent>
            <DialogActions>
              {jwtToken ? (
                <Button
                  color="primary"
                  onClick={() =>
                    window.ReactNativeWebView.postMessage(dialogOpen)
                  }
                >
                  View image source
                </Button>
              ) : (
                <Button color="primary" component={MyLink}>
                  View image source
                </Button>
              )}
              <Button
                onClick={() => {
                  openImageDialog(false)
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )
      }),
    ),
  ),
)
